import React from "react";
import karim from "./CyBoRg.jpg";

const About = () => {
  return (
    <div className="about" id="about">
      <div className="container">
        <div className="row">
          <div className="col-sm-6">
            <img src={karim} alt="karim" />
          </div>
          <div className="col-sm-6">
            <h1 className="title2" style={{ color: "#f9ab00" }}>
              About Me
            </h1>
            <ul class="list-unstyled p-3">
              <li>
                <span class="spans">Education:</span>
                <p class="pars">Student In Secondary School</p>
              </li>
              <li>
                <span class="spans">Date Of Birth:</span>
                <p class="pars">26 Septemper 2004</p>
              </li>
              <li>
                <span class="spans">Address:</span>
                <p class="pars">Egypt - Cairo</p>
              </li>
              <li>
                <span class="spans">Experience:</span>
                <p class="pars">3 Years</p>
              </li>
              <li>
                <span class="spans">Languages:</span>
                <p class="pars">Arabic - English</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
